<template>
  <div class="transport-form">
    <div v-if="initializing" class="text-center my-3">
      <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
    </div>

    <template v-else>
      <page-header :transport="transport"/>

      <table class="table table-sm">
        <tbody>
          <tr>
            <td colspan="6" class="border-right">
              شماره حواله تحویل :

              {{ transport.deliveryNumber }}
            </td>

            <td colspan="6" class="border-left">
              شماره سفارش :

              {{ stock.orderCode }}
            </td>
          </tr>

          <tr>
            <td colspan="12" class="border-left border-right">
              نام خریدار :

              {{ getUserDisplayName(transport.dealer) }}
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="4" class="bg-light border-right border-left">
              شرح محصول
            </td>

            <td :colspan="transport.courierId ? 2 : 4" class="bg-light border-right border-left">
              مقدار
              ( {{ stock.model.product.type.unit.name }} )
            </td>

            <td :colspan="transport.courierId ? 2 : 4" class="bg-light border-left">
              تعداد
              {{ stock.model.product.type.bundleName }}
            </td>

            <td v-if="transport.courierId" colspan="2" class="bg-light border-left">
              استان/شهر مقصد
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="4" class="border-right border-left">
              {{ stock.model.product.title }}
            </td>

            <td :colspan="transport.courierId ? 2 : 4" class="border-left">
              {{ (transport.bundlesCount * stock.bundleRate).toLocaleString() }}
            </td>

            <td :colspan="transport.courierId ? 2 : 4" class="border-left">
              {{ stock.bundleRate }}
            </td>

            <td v-if="transport.courierId" colspan="2" class="border-left">
              {{ transport.unloadProvince.name }}/{{ transport.unloadCity.name }}
            </td>
          </tr>

          <tr class="text-center">
            <td colspan="12" class="bg-light border-right border-left">
              مشخصات راننده و وسیله تحویل
            </td>
          </tr>

          <tr>
            <td colspan="4" class="border-right">
              نام و نام خانوادگی :

              {{ model.driverFirstName }} {{ model.driverLastName }}
            </td>

            <td colspan="4" class="border-0">
              کد ملی :

              {{ model.driverNationalCode }}
            </td>

            <td colspan="4" class="border-left border-top-0">
              شماره هوشمنده راننده :

              {{ model.driverSmartNumber }}
            </td>
          </tr>

          <tr>
            <td colspan="4" class="border-right border-top-0">
              شماره گواهینامه :

              {{ model.driverLicenseNumber }}
            </td>

            <td colspan="4" class="border-0">
              محل صدور گواهینامه :

              {{ model.driverIssuePlace }}
            </td>

            <td colspan="4" class="border-left border-top-0">
              تلفن همراه :

              {{ model.driverPhoneNumber }}
            </td>
          </tr>

          <tr>
            <td colspan="6" class="border-right border-top-0">
              شماره هوشمند وسیله حمل :

              {{ model.vehicleSmartNumber }}
            </td>

            <td colspan="6" class="border-left border-top-0">
              شماره انتظامی :
              ایران
              {{ model.plateCode }}
              -
              {{ model.plateNumber }}
            </td>
          </tr>

          <tr>
            <td colspan="12" class="border-left border-right border-top-0">
              شماره ردیف باربری :

              {{ model.cargoRow }}
            </td>
          </tr>

          <tr class="h5">
            <td colspan="12" class="border-left border-right border-bottom py-2">
              اعتبار مجوز :

              از تاریخ <date-display :value="model.validFrom" time icon-class=""/>

              تا تاریخ <date-display :value="model.validUntil" time icon-class=""/>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="text-center">
        راننده گرامی لطفا به زمان اعتبار مجوز توجه فرمایید. درصورت تاخیر در ورود به انبار و باطل شدن حواله تحویل مسئولیت هرگونه خسارت وارده به عهده شما می باشد.
      </p>

      <div class="d-flex justify-content-end">
        امضا و اثر انگشت راننده
      </div>
    </template>
  </div>
</template>

<script>
import PageHeader from './PageHeader'
import { DateDisplay } from '@/components/shared'

export default {
  name: 'TransportLicense',
  components: {
    PageHeader,
    DateDisplay
  },
  props: ['transportId', 'licenseId'],
  data () {
    return {
      initializing: true,
      model: null,
      stock: null,
      transport: null
    }
  },
  computed: {
    signatory () {
      const signatories = this.transport && this.transport.courier && this.transport.courier.signatories
      return signatories && signatories.length && signatories.find(o => o.contractSignatory)
    }
  },
  mounted () {
    Promise.all([
      this.getModel(),
      this.getTransport()
    ])
    .then(() => {
      this.initializing = false
    })
  },
  methods: {
    getModel () {
      return this.$api.transports.getLicense(this.transportId, this.licenseId)
      .then(res => {
        this.model = res

        if (!this.model)
          this.$router.push('/transports')
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
      })
    },
    getTransport () {
      return this.$api.transports.getById(this.transportId, { include: 'Courier' })
      .then(res => {
        this.stock = res
        this.transport = res.transports[0]
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
      })
    },
    getUserDisplayName (user) {
      return this.$api.account.getUserDisplayName(user)
    }
  }
}
</script>

<style lang="scss" scoped>
.transport-form {
  .table td {
    border-color: #000 !important;
  }
}
</style>